import React, {Fragment} from 'react';

import cs from 'classnames';

import {StyledTeamListItem} from 'app/teams/components/TeamItem';

import {LoadingLine} from './LoadingLine';
const widths = [1, 0.8, 1, 0.3, 1, 0.7];
export type LoadingListProps = {
  lines?: number;
  small?: boolean;
};
export const LoadingList = ({lines = 6, small = false}: LoadingListProps) => (
  <Fragment>
    {Array.from(Array(lines)).map((_, i) => (
      <StyledTeamListItem key={i}>
        <div
          className={cs('col-12 d-flex align-items-center', {
            'py-2': !small,
          })}
        >
          <LoadingLine
            height="1.2rem"
            width={`${widths[i % widths.length] * 100}%`}
          />
        </div>
      </StyledTeamListItem>
    ))}
  </Fragment>
);
